import { Store as PullStateSTore } from "pullstate";

export const Store = new PullStateSTore({ session: undefined, config: undefined, player: {}, cookies: {} });
export const PlayerStore = new PullStateSTore({ tracklist: [], position: 0 });
